import React from 'react';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { Reference } from './Reference';
import { BackToLandingPageLink } from './BackToLandingPageLink';
import { NewBooking } from '../../../domain/booking/models/NewBooking';

interface IConfirmationNewBookingProps {
	booking: NewBooking;
}

export const ConfirmationNewBooking = ({
	booking,
}: IConfirmationNewBookingProps) => {
	const { t } = useTranslation();
	const { reference } = booking;
	const email = booking.personalDetails?.email;

	return (
		<>
			<Reference reference={reference} />

			<p>{t('web_parking_confirmation_new_booking_message')}</p>

			{email && (
				<p>
					{t('web_parking_confirmation_new_booking_email_message', {
						user_email_address: email,
					})}
				</p>
			)}

			<p>
				<BackToLandingPageLink />
			</p>
		</>
	);
};
